<template>
  <div class="popup-on-leave">
    <div class="text-right font-weight-bold">
      <v-icon aria-label="Close" @click="closeModal()">mdi-close</v-icon>
    </div>
    <div class="popup-on-leave-title">
      <h2 class="mb-2">ĐĂNG KÝ NGHỈ PHÉP</h2>
    </div>
    <v-form ref="form">
      <div class="detail-class mt-4 pa-5 pb-1">
        <p>
          <span>Lớp:</span>
          <b class="ml-1">{{ detailStudent.name }}</b>
        </p>
        <p>
          <span>Chờ duyệt:</span>
          <b class="ml-1">{{ studentOffQuota ? studentOffQuota.pending : '--' }} </b>buổi
        </p>
        <p>
          <span>Đã duyệt:</span>
          <b class="ml-1">{{ studentOffQuota ? studentOffQuota.used : '--' }} </b>buổi
        </p>
        <p>
          <span>Quota:</span>
          <b class="ml-1">{{ studentOffQuota ? studentOffQuota.quota : '--' }} </b>buổi
        </p>
      </div>
      <div class="popup-on-leave-day mt-4 pl-3 pr-3" v-if="checkAuthOnLeaveNReverse()">
        <div>
          <div class="mt-3 mb-2 leave-day-item">Chọn ngày nghỉ phép</div>
          <v-menu
            ref="dateTime"
            :close-on-content-click="false"
            :nudge-top="25"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="listAboutHolidays.dateTime"
                readonly
                v-bind="attrs"
                v-on="on"
                background-color="white"
                placeholder="-- / -- / ----"
                :rules="dateTimeRules"
              ></v-text-field>
            </template>
            <v-sheet>
              <v-list dense>
                <v-list-item
                  v-for="(item, i) in listHolidays"
                  :key="i"
                  @click="inputCloseDatePicker('dateTime', item)"
                >
                  <v-list-item-content>
                    <v-list-item-title>
                      <span>
                        <b class="mr-3">{{item.day}}</b>
                        {{item.fromTime}} - {{item.toTime}}
                      </span>
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-sheet>
          </v-menu>
        </div>
        <div>
          <div class="mt-3 mb-2 leave-day-item">Lý do nghỉ phép</div>
          <v-text-field
            v-model="listAboutHolidays.reason"
            background-color="white"
            placeholder="Nhập lý do"
          ></v-text-field>
        </div>
      </div>
      <div class="popup-on-leave-confirm pt-3 pb-5 text-center" v-if="checkAuthOnLeaveNReverse()">
        <v-btn
          rounded
          color="#EFF0F7"
          class="text-black mr-3 btn-on-leave btn-ship"
          @click="closeModal()"
          depressed
        >
          Bỏ qua
        </v-btn>
        <v-btn
          rounded
          color="#FF6609"
          class="btn-on-leave btn-confirm-on-leave"
          depressed
          :disabled="isDisableBtnConfirm"
          @click="checkQuotaOff()"
        >
          Xác nhận
        </v-btn>
      </div>
    </v-form>
    <div class="popup-on-leave-history my-5">
      <p>LỊCH SỬ NGHỈ PHÉP</p>
      <div v-if="listHolidayHistory.length" class="popup-history mt-3">
        <div v-for="(item, index) in listHolidayHistory" :key="index" class="time-count-history pa-2">
          <span class="leave-code text-center">{{ item.code }}</span>
          <div class="time-count-history-color">
            {{ item.day}}
          </div>
          <span class="time">
            {{ `${item.fromTime} - ${item.toTime}` }}
          </span>
          <div
            class="status-dayoff text-center"
            :style="
              `color: ${item.status.color};
              border: 1px solid ${item.status.color}`
            "
          >
            {{ item.status.name }}
          </div>
          <!-- <v-icon
            class="ml-2"
            color="pink"
            style="width:5%"
            v-if="item.status.id === 1"
            @click="onClickEditHistory(item)"
          >
            mdi-pencil
          </v-icon> -->
        </div>
      </div>
      <div v-else class="text-center w-100">
        Không có dữ liệu
      </div>
    </div>
    <v-dialog v-model="isPopupWarning" width="530" persistent>
      <v-card class="pa-5 sync-account-classin">
        <div class="close-popup"><v-icon @click="isPopupWarning = false">mdi-close</v-icon></div>
        <div class="title-header">
          <h3 class="mt-3">Quá quota nghỉ phép</h3>
        </div>
        <div class="dialog-content mt-3 mb-3 pt-3 pb-3">
          <span>
            Học sinh đã quá quota nghỉ phép. Bạn có muốn duyệt phiếu nghỉ phép không?
            Vui lòng chọn <b>Xác nhận</b> để đồng ý!
          </span>
        </div>
        <div class="mt-3 text-center">
          <v-btn color="gray" small class="mr-2" @click="isPopupWarning = false">hủy</v-btn>
          <v-btn color="pink" v-if="!idFormEdit" style="color:#fff" small class="ml-2" @click="confirmOnLeave()">xác nhận</v-btn>
          <v-btn color="pink" v-else style="color:#fff" small class="ml-2" @click="confirmUpdateOnLeave()">xác nhận</v-btn>
        </div>
      </v-card>
    </v-dialog>
    <v-dialog v-model="isEditLeave" width="600" persistent>
      <v-card class="pa-5 popup-update-leave">
        <div class="close-popup"><v-icon @click="closeModalEditLeave()">mdi-close</v-icon></div>
        <div class="title-header text-center">
          <h2 class="mb-2">CẬP NHẬT PHIẾU NGHỈ PHÉP {{ leaveCode }}</h2>
          <span>(Khi cập nhật, phiếu sẽ quay lại trạng thái Chờ duyệt)</span>
        </div>
        <div class="dialog-content">
          <v-form ref="forms">
            <div class="popup-on-leave-day mt-4">
              <div>
                <div class="mt-3 mb-2 leave-day-item">Chọn ngày nghỉ phép</div>
                <v-menu
                  ref="dateTime"
                  :close-on-content-click="false"
                  :nudge-top="25"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="bodyEditLeave.dateTime"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      background-color="white"
                      placeholder="-- / -- / ----"
                      :rules="dateTimeEditRules"
                    ></v-text-field>
                  </template>
                  <v-sheet>
                    <v-list dense>
                      <v-list-item
                        v-for="(item, i) in listHolidays"
                        :key="i"
                        @click="inputDatePicker('dateTime', item)"
                      >
                        <v-list-item-content>
                          <v-list-item-title>
                            <span>
                              <b class="mr-3">{{item.day}}</b>
                              {{item.fromTime}} - {{item.toTime}}
                            </span>
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-sheet>
                </v-menu>
              </div>
              <div>
                <div class="mt-3 mb-2 leave-day-item">Lý do nghỉ phép</div>
                <v-text-field
                  v-model="bodyEditLeave.reason"
                  background-color="white"
                  placeholder="Nhập lý do"
                ></v-text-field>
              </div>
            </div>
            <div class="popup-on-leave-confirm pt-3 pb-5 text-center">
              <v-btn
                rounded
                color="#EFF0F7"
                class="text-black mr-3 btn-on-leave btn-ship"
                @click="closeModalEditLeave()"
                depressed
                small
              >
                Bỏ qua
              </v-btn>
              <v-btn
                rounded
                color="#FF6609"
                class="btn-on-leave btn-confirm-on-leave"
                depressed
                :disabled="isDisableBtnConfirm"
                small
                @click="checkEditQuotaOff()"
              >
                Xác nhận
              </v-btn>
            </div>
          </v-form>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import moment from 'moment';
import { mapActions } from 'vuex';
import StudentCareServices from '@/services/StudentCareServices';

export default {
  props: {
    detailStudent: {
      type: Object,
    },
    isPopupOnLeave: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      isDisableBtnConfirm: false,
      listAboutHolidays: {
        dateTime: null,
        caseId: null,
        reason: '',
      },
      listHolidays: [],
      listHolidayHistory: [],
      dateTimeRules: [
        (v) => !!v || 'Ngày nghỉ phép không được để trống.',
        (v) => moment(v) > moment().startOf('day') || 'Phải lớn hơn ngày hiện tại',
      ],
      dateTimeEditRules: [
        (v) => !!v || 'Ngày nghỉ phép không được để trống.',
        (v) => moment(v) > moment().startOf('day') || 'Phải lớn hơn ngày hiện tại',
      ],
      studentOffQuota: null,
      isPopupWarning: false,
      isEditLeave: false,
      leaveCode: '',
      bodyEditLeave: {
        dateTime: null,
        caseId: null,
        reason: '',
      },
      idFormEdit: null,
    };
  },

  created() {
    this.fetchDayOff();
  },

  methods: {
    ...mapActions('student_care', ['getDayOff', 'confirmOnDayOff']),

    // Chosen Date => Close datePicker
    inputCloseDatePicker(ref, item) {
      this.$refs[ref].save([]);
      this.listAboutHolidays.dateTime = item.dateTime;
      this.listAboutHolidays.caseId = item.caseId;
    },
    inputDatePicker(ref, item) {
      this.$refs[ref].save([]);
      this.bodyEditLeave.dateTime = item.dateTime;
      this.bodyEditLeave.caseId = item.caseId;
    },

    // Lấy danh sách ngày nghỉ
    async fetchDayOff() {
      const res = await this.getDayOff(this.detailStudent.student_product_id);
      if (res) {
        this.listHolidays = res.studentSchedule.filter((item) => {
          const temp = item;
          return temp.isDayOff === false;
        });
        this.listHolidayHistory = res.studentOff;
        this.studentOffQuota = res.studentOffQuota;
        if (!res.studentSchedule.length) {
          this.isDisableBtnConfirm = true;
        }
      }
    },

    // kiểm tra quá số buổi nghỉ phép
    checkQuotaOff() {
      const isValid = this.$refs.form.validate();
      if (isValid) {
        if (this.studentOffQuota.used >= this.studentOffQuota.quota) {
          this.isPopupWarning = true;
          return;
        }
        this.confirmOnLeave();
      }
    },
    checkEditQuotaOff() {
      const isValid = this.$refs.forms.validate();
      if (isValid) {
        if (this.studentOffQuota.used >= this.studentOffQuota.quota) {
          this.isPopupWarning = true;
          return;
        }
        this.confirmUpdateOnLeave();
      }
    },
    // Xác Nhận Lịch Nghỉ
    async confirmOnLeave() {
      const params = {
        type: 'days',
        dayoff: this.listAboutHolidays,
        student_product_id: this.detailStudent.student_product_id,
      };
      const res = await this.confirmOnDayOff(params);
      if (res && res.success) {
        this.$swal({
          type: 'success',
          title: 'Xác nhận lịch nghỉ thành công',
          timer: 1500,
        });
        this.listAboutHolidays = {
          dateTime: null,
          caseId: null,
          reason: '',
        };
        this.$refs.form.resetValidation();
        this.fetchDayOff();
        this.isPopupWarning = false;
        return;
      }
      this.$swal({
        type: 'error',
        title: 'Lỗi',
        text: res.message ?? 'Đã có lỗi xảy ra khi đăng ký nghỉ phép!',
        timer: 1500,
      });
      this.isPopupWarning = false;
    },

    // xác nhận cập nhật lịch nghỉ
    async confirmUpdateOnLeave() {
      const student = {
        studentId: this.detailStudent.student_product_id,
        leaveId: this.idFormEdit,
      };
      const params = {
        type: 'days',
        dayoff: this.bodyEditLeave,
      };
      const res = await StudentCareServices.updateDayOff(student, params);
      if (res && res.success) {
        this.$swal({
          type: 'success',
          title: 'Cập nhật lịch nghỉ thành công',
          timer: 1500,
        });
        this.bodyEditLeave = {
          dateTime: null,
          caseId: null,
          reason: '',
        };
        this.$refs.forms.resetValidation();
        this.closeModalEditLeave();
        this.isPopupWarning = false;
        this.fetchDayOff();
        return;
      }
      this.$swal({
        type: 'error',
        title: 'Lỗi',
        text: res.message ?? 'Đã có lỗi xảy ra khi cập nhật nghỉ phép!',
        timer: 1500,
      });
      this.isPopupWarning = false;
    },

    validate() {
      this.$refs.form.validate();
    },

    closeModal() {
      Bus.$emit('closePopupOnLeave');
      this.isDisableBtnConfirm = false;
      this.listAboutHolidays = {
        dateTime: null,
        caseId: null,
        reason: '',
      };
    },

    // Khi click button edit => Đóng các trạng thái edit khác
    onClickEditHistory(data) {
      this.idFormEdit = data.id;
      this.isEditLeave = true;
      this.leaveCode = data.code;
      const dateArray = data.day.substr(-10, 10).split('/');
      const dateTime = `${dateArray[2]}/${dateArray[1]}/${dateArray[0]} ${data.fromTime}`;
      const dateTimeFormat = moment(dateTime).format('YYYY-MM-DD HH:mm:ss');
      this.bodyEditLeave = {
        dateTime: dateTimeFormat,
        caseId: data.caseId,
        reason: data.reason,
      };
    },

    closeModalEditLeave() {
      this.isEditLeave = false;
      this.leaveCode = '';
      this.idFormEdit = null;
      this.bodyEditLeave = {
        dateTime: null,
        caseId: null,
        reason: '',
      };
    },
  },

  watch: {
    listAboutHolidays: {
      handler(value) {
        if (value && value.dateTime) {
          this.validate();
        }
      },
      deep: true,
    },
    isPopupOnLeave: {
      handler(newVal) {
        if (newVal) {
          this.fetchDayOff();
        }
      },
      deep: true,
    },
  },
};
</script>
<style scoped lang="scss">
.popup-on-leave {
  background: #fff;
  padding: 16px;
  .popup-on-leave-title {
    width: 100%;
    text-align: center;
    span {
      color: #bdbdbd;
    }
    border-bottom: 1px solid #E0E0E0;
  }
  .popup-on-leave-title-time {
    display: flex;
    color: #828282;
    font-weight: 700;
    font-size: 15px;
    cursor: pointer;
    .title-choose:hover {
      color: #8ebfff;
    }
    .activeOnLeave {
      color: #2f80ed;
      border-bottom: 3px solid #2f80ed;
    }
  }
  .popup-on-leave-time {
    max-height: 500px;
    overflow: auto;
    margin-top: 11px;
    .popup-tab-title {
      display: flex;
      width: 100%;
      background: #f7f7fc;
      height: 33px;
      justify-content: space-between;
      align-items: center;
      padding: 0px 35px 0px 11px;
      border-radius: 4px 4px 0px 0px;
    }
    .popup-on-leave-time-count {
      display: flex;
      justify-content: space-between;
      padding: 10px;
      background: #f6f6f6;
      border-bottom: 1px solid #e0e0e0;
      .time-count-item {
        display: flex;
        .time-count-item-color {
          background: #ffe4e4;
          color: #ff4b4b;
          padding: 2px 7px;
          border-radius: 4px;
          margin-right: 6px;
          font-weight: 700;
        }
      }
    }
  }
  .popup-history {
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    .time-count-history {
      display: flex;
      width: 100%;
      border: 1px solid #E0E0E0;
      .time-count-history-color {
        background: #FFE4E4;
        color: #FF4B4B;
        padding: 1px 7px;
        font-size: 12px;
        border-radius: 4px;
        margin-right: 6px;
        font-weight: 600;
        width: 21%;
      }
      .time {
        line-height: 11px;
        font-size: 11.5px;
        display: flex;
        align-items: center;
        color: #333333;
        width: 29%;
      }
      .status-dayoff {
        font-size: 12px;
        border-radius: 10px;
        padding: 1px 10px;
        width: 20%;
      }
      .leave-code {
        color: #0088FF;
        width: 20%;
      }
    }
  }
  .text-black {
    color: black !important;
  }
  .btn-on-leave {
    text-transform: none;
    height: 24px;
    font-size: 12px;
    font-weight: 600;
    min-width: 95px;
  }
  .v-btn.v-size--default {
    padding: 3px 15px !important
  }
  .btn-confirm-on-leave {
    color: #fff;
  }
  .popup-on-leave-history {
    p {
      font-weight: 700;
      font-size: 12px;
      color: #828282;
    }
  }
  .detail-class {
    background: #D9D9D961;
  }
  ::v-deep .v-input__slot::before {
    border-style: none !important;
  }
  ::v-deep .v-icon.v-icon {
    font-size: 16px;
  }
  .highlight-dayoff {
    background: #e0e0e0;
  }
}
.text-center {
  text-align: center;
}
.popup-on-leave-day {
  display: flex;
  width: 100%;
  justify-content: space-around;
  background: #f6f6f6;
  .leave-day-item {
    font-weight: 700;
  }
}
.popup-on-leave-day ::v-deep .v-text-field {
  padding: 0;
}
.popup-on-leave-day ::v-deep .v-text-field .v-input__control .v-input__slot {
  min-height: 32px !important;
  border-radius: 4px;
  border-color: #fff;
  padding: 0 10px;
}
.popup-on-leave-confirm {
  background: #f6f6f6;
}
.sync-account-classin, .popup-update-leave {
  .close-popup {
    position: absolute;
    right: 26px;
  }
}
.sync-account-classin .dialog-content {
  border-top: 1px solid #D2D2D2;
  border-bottom: 1px solid #D2D2D2;
}
::v-deep .theme--light.v-list-item:not(.v-list-item--active):not(.v-list-item--disabled) {
  border: 1px solid #e0e0e0 !important;
}
::v-deep .v-list {
  padding: 0 !important;
}
</style>
